import API, { defaultHeaders, IRI } from '@/api';

const fetchDeleteMany = payload => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
  return fetch(`${API}${IRI.codes}`, {
    headers,
    method: 'DELETE',
    body: JSON.stringify(payload),
  });
};

export default fetchDeleteMany;
